/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationBareLogPreviewItemDto
 */
export interface OrganizationBareLogPreviewItemDto {
    /**
     * 
     * @type {string}
     * @memberof OrganizationBareLogPreviewItemDto
     */
    logId: string;
    /**
     * Golden-record messageType; "unknown" when missing
     * @type {string}
     * @memberof OrganizationBareLogPreviewItemDto
     */
    messageType: string;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationBareLogPreviewItemDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationBareLogPreviewItemDto
     */
    receivedAt: Date | null;
    /**
     * Original payload from metadata.rawMessage
     * @type {object}
     * @memberof OrganizationBareLogPreviewItemDto
     */
    rawMessage: object;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBareLogPreviewItemDto
     */
    assetId: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationBareLogPreviewItemDto
     */
    serialNumber: string;
}

/**
 * Check if a given object implements the OrganizationBareLogPreviewItemDto interface.
 */
export function instanceOfOrganizationBareLogPreviewItemDto(value: object): value is OrganizationBareLogPreviewItemDto {
    if (!('logId' in value) || value['logId'] === undefined) return false;
    if (!('messageType' in value) || value['messageType'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('receivedAt' in value) || value['receivedAt'] === undefined) return false;
    if (!('rawMessage' in value) || value['rawMessage'] === undefined) return false;
    if (!('assetId' in value) || value['assetId'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    return true;
}

export function OrganizationBareLogPreviewItemDtoFromJSON(json: any): OrganizationBareLogPreviewItemDto {
    return OrganizationBareLogPreviewItemDtoFromJSONTyped(json, false);
}

export function OrganizationBareLogPreviewItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationBareLogPreviewItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'logId': json['logId'],
        'messageType': json['messageType'],
        'createdAt': (new Date(json['createdAt'])),
        'receivedAt': (json['receivedAt'] == null ? null : new Date(json['receivedAt'])),
        'rawMessage': json['rawMessage'],
        'assetId': json['assetId'],
        'serialNumber': json['serialNumber'],
    };
}

export function OrganizationBareLogPreviewItemDtoToJSON(json: any): OrganizationBareLogPreviewItemDto {
    return OrganizationBareLogPreviewItemDtoToJSONTyped(json, false);
}

export function OrganizationBareLogPreviewItemDtoToJSONTyped(value?: OrganizationBareLogPreviewItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logId': value['logId'],
        'messageType': value['messageType'],
        'createdAt': value['createdAt'].toISOString(),
        'receivedAt': value['receivedAt'] == null ? value['receivedAt'] : value['receivedAt'].toISOString(),
        'rawMessage': value['rawMessage'],
        'assetId': value['assetId'],
        'serialNumber': value['serialNumber'],
    };
}

